import { Component } from 'react';
import PropTypes from 'prop-types';
import { addErrorToReport } from '@americanexpress/one-app-ducks';

/*
  TODO: Convert this when there is an official hook equivalent to componentDidCatch
  React team does recommend using a package called react-error-boundary
  https://github.com/bvaughn/react-error-boundary
*/
export default class ErrorReporter extends Component {
  constructor() {
    super();
    this.handleOnError = this.handleOnError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  componentDidMount() {
    window.addEventListener('error', this.handleOnError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentDidCatch(error, info) {
    const { publicGuid } = this.props;
    this.addErrorToReport(error, {
      info,
      msgType: 'MYCA-Tenant',
      collectionMethod: 'componentDidCatch',
      publicGuid: `${publicGuid}`,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleOnError);
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  handleOnError(err) {
    const { publicGuid } = this.props;
    const {
      message, filename, lineno, colno, error,
    } = err;

    this.addErrorToReport(
      err,
      {
        message,
        filename,
        lineno,
        colno,
        error,
        msgType: 'MYCA-Tenant',
        collectionMethod: 'error',
        publicGuid: `${publicGuid}`,
      }
    );
  }

  handleUnhandledRejection(e) {
    const { publicGuid } = this.props;
    const { message, stack, body } = e.reason || { };
    // eslint-disable-next-line no-underscore-dangle -- underscore
    const { browserInfo } = (e.target && e.target._satellite) || { };
    const { effectiveType } = (
      e.target && e.target.navigator && e.target.navigator.connection
    ) || { };

    this.addErrorToReport(e, {
      message,
      stack,
      body,
      msgType: 'MYCA-Tenant',
      collectionMethod: 'unhandledrejection',
      publicGuid: `${publicGuid}`,
      effectiveType,
      browserInfo,
    });
  }

  addErrorToReport(error, otherData) {
    const { dispatch } = this.props;
    dispatch(addErrorToReport(error, otherData));
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ErrorReporter.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  publicGuid: PropTypes.string,
};

ErrorReporter.defaultProps = {
  children: null,
  publicGuid: null,
};
